import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Opt a mutating request out of the global progress bar. Use it for writes the
 * user did not initiate -- background sync, autosave, telemetry -- where a progress
 * signal would be noise rather than feedback.
 */
export const SKIP_BUSY_INDICATOR = new HttpContextToken<boolean>(() => false);
